import { MediaActionTypes, All } from '../actions/media.actions';
import { Media, MediaSearchCriteria } from '@app/shared/models/media';
import { Decoration } from '@app/shared/models/decoration';

// define State interface
export interface State {
  // is a user authenticated?
  selectedMedia: Media | null;
  // if authenticated, there should be a user object
  decorations: Decoration[] | null;
  medias: Media[] | null;
  searchCriteria: MediaSearchCriteria | null;
  errorMessage: string | null;
  isEditing: boolean | null;
  actionType: string | null;
}

// define initial state
export const initialState: State = {
  selectedMedia: null,
  medias: null,
  decorations:null,
  searchCriteria:null,
  errorMessage: null,
  isEditing:false,
  actionType:null,
};

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case MediaActionTypes.GET_MEDIAS_SUCCESS: {
      return {
        ...state,
        selectedMedia: null,
        decorations: null,
        medias: action.payload.medias,
        searchCriteria:action.payload.searchCriteria,
        errorMessage:null,
        actionType:action.type,
      };
    }
    case MediaActionTypes.GET_DECORATIONS_SUCCESS: {
      return {
        ...state,
        selectedMedia: null,
        medias: null,
        decorations:action.payload.decorations,
        searchCriteria:action.payload.searchCriteria,
        errorMessage:null,
        actionType:action.type,
      };
    }

    case MediaActionTypes.SET_MEDIA: {
      return {
        ...state,
        selectedMedia: action.payload.media,
        actionType:action.type,
      };
    }
    case MediaActionTypes.CREATE_MEDIA:
    case MediaActionTypes.EDIT_MEDIA: {
      return {
        ...state,
        selectedMedia: action.payload.media,
        isEditing: action.payload.isEditing,
        actionType:action.type,
      };
    }
    case MediaActionTypes.GET_DECORATIONS_FAILURE:
    case MediaActionTypes.SET_MEDIA_FAILURE:
    case MediaActionTypes.GET_MEDIAS_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error.statusText,
        actionType:action.type,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/reducers/media.reducer.ts